import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {ID} from '../../../../../../../../_metronic/helpers'
import {schemaOrderLaundryReception} from '../../../../../../util/validationLavanderia'
import {getMasterService} from '../../../../../central/services'
import {MasiveReception, PointModel, SelectModel} from '../../../../model'
import {createReceptioMasive, getPoint} from '../../../../services'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../components/UI/Select'
import {InputDateLav} from '../../../../../../components/UI/Input'
import {ShowSnackBar} from '../../../../../../util/functions'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getList: () => void
  arrayId: ID[]
  fromLaundry?: boolean
}

const ModalReception: FC<Props> = ({show, setShow, arrayId, getList, fromLaundry}) => {
  const [typeFurniture, setTypeFurniture] = useState<MasiveReception[] | any>([])
  const [minLength, setMinLength] = useState<string>('')
  const [points, setPoints] = useState<SelectModel[] | any>([])
  const {currentTabItem} = useLavanderia()

  const methods = useForm<MasiveReception>({
    resolver: yupResolver(schemaOrderLaundryReception),
  })
  const {
    control,
    handleSubmit,
    setError,
    register,
    formState: {errors},
    watch,
    setValue,
  } = methods

  const getReceptionPlaceList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'LugarRecepcion',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  const getPointList = async () => {
    try {
      let pointSelected = currentTabItem.laundrySelected[0]
      let obj: PointModel = {
        isCombo: true,
        siteId: pointSelected.siteId ?? '',
        companiaId: pointSelected.companiaId ?? '',
        clienteId: pointSelected.clienteId ?? '',
        campamentoId: pointSelected.campamentoId ?? '',
      }
      const response = await getPoint(obj, 1)
      const data = response.data.data
      const principalPoint = data.find((point: PointModel) => point.principal)
      if (principalPoint?.id === pointSelected?.puntoId) {
        setValue('puntoId' as any, principalPoint?.id)
      }
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      setPoints(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de puntos de lavandería:', error)
    }
  }

  useEffect(() => {
    getReceptionPlaceList()
  }, [])

  useEffect(() => {
    if (fromLaundry) {
      setValue('lugarRecepcion', 'EN HABITACIÓN')
      setValue('fechaRecepcion', new Date().toISOString().split('T')[0])
      getPointList()
    }
  }, [fromLaundry])

  const handleClose = () => {
    setShow(false)
  }
  const onSubmit = async (data: MasiveReception) => {
    try {
      let obj = {
        orders: arrayId,
        ...data,
      }
      const {data: res} = await createReceptioMasive(obj)
      if (!res.error) {
        handleClose()
        getList()
        ShowSnackBar('Se actualizó con exito')
        //mostrar snackbar
      } else {
        ShowSnackBar(res.message, 'error')
      }
    } catch (error) {}
  }

  const handleGetDateReception = (e: any) => {
    let value = e.target.value
    setMinLength(value)
    setError('fechaRecepcion', {})
  }
  const handleGetDateDate = (e: any) => {
    // let value = e.target.value
    setError('fechaProgramada', {})
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Recepción de Ropa de Huésped Masiva</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                {fromLaundry && (
                  <div className='mb-2 col-6'>
                    <label className='required'>Punto de Lavandería</label>
                    <Select control={control} name='puntoId' data={points} errors={errors} />
                  </div>
                )}
                <div className='mb-2 col-6'>
                  <label className='required'>Lugar de recepción</label>
                  <Select
                    control={control}
                    name='lugarRecepcion'
                    data={typeFurniture}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label>Fecha de recepción:</label>
                  <InputDateLav
                    name='fechaRecepcion'
                    register={register}
                    errors={errors}
                    onChange={handleGetDateReception}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label>Fecha programada:</label>
                  <InputDateLav
                    name='fechaProgramada'
                    register={register}
                    minValue={minLength}
                    errors={errors}
                    onChange={handleGetDateDate}
                  />
                </div>
              </div>
              {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}

              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalReception}
